module.exports = " <div class=main> <np-preview></np-preview> <np-view-options></np-view-options> </div>";